import { useEffect } from 'react';
import { dispatchAction } from '@ardoq/rxbeach';
import { ViewIds } from '@ardoq/api-types';
import {
  TimelineRenderingLayer,
  TimelineRenderingLayerStaticProps,
  TimelineRenderingLayerViewSettingsProps,
  TimelineViewCommands,
  ViewModelSourceData,
} from '@ardoq/timeline2024';
import { readViewComponentIds } from 'streams/viewComponentIds$';
import { getTimelineViewComponentIds } from './viewComponentIds';

const publishViewComponentIds = (
  renderedComponents: Parameters<typeof getTimelineViewComponentIds>[0]
) =>
  dispatchAction(
    readViewComponentIds({
      [ViewIds.TIMELINE]: getTimelineViewComponentIds(renderedComponents),
    })
  );

export type WorkspaceModeTimelineSourceDataLayerProps =
  TimelineRenderingLayerStaticProps &
    TimelineRenderingLayerViewSettingsProps & {
      commands: TimelineViewCommands;
      sourceData: ViewModelSourceData;
    };

const WorkspaceModeTimelineSourceDataLayer = ({
  viewInstanceId,
  settingsControlsHandlers,
  commands,
  ViewLegendComponent,
  EmptyStateComponent,
  uiOnlyViewSettings,
  sourceData,
}: WorkspaceModeTimelineSourceDataLayerProps) => {
  const { fieldsAndItemsSourceData, viewRelevantComponentsScopeData } =
    sourceData;

  useEffect(() => {
    publishViewComponentIds({
      fieldsAndItemsSourceData,
      viewRelevantComponentsScopeData,
    });
  }, [fieldsAndItemsSourceData, viewRelevantComponentsScopeData]);

  return (
    <TimelineRenderingLayer
      viewInstanceId={viewInstanceId}
      settingsControlsHandlers={settingsControlsHandlers}
      commands={commands}
      ViewLegendComponent={ViewLegendComponent}
      EmptyStateComponent={EmptyStateComponent}
      sourceData={sourceData}
      uiOnlyViewSettings={uiOnlyViewSettings}
    />
  );
};

export { WorkspaceModeTimelineSourceDataLayer };
